import axiosInstance from "@/api/axios";
// import toastService from "@/services/toastService";
export interface UserData {
  newSubUserLicenses: {
    price_id: string;
    quantity: number;
  }[];
}

export const fetchCatalogue = async () => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/licenses/catalogue",
        // data: data,
      });
      console.log("Cataloge", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const fetchCatalogueForNewSubscription = async () => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/licenses/catalogueForNewSubscription",
        // data: data,
      });
      console.log("AddCataloge", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const updateUserLicense = async (data: { subscriptionId : string, subUserLicenses: { price_id: string; quantity: number }[] }) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "PUT",
        url: "/odoo/api/v1/licenses",
        data: data,
      });
      console.log("response", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const fetchAllUpcomingInvoices = async (subscriptionId:string) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/subscriptions/allUpcomingInvoiceItems",
     
    params: {
        subscriptionId: subscriptionId
        
      },
    
      });
      console.log("All Upcoming Invoices", response);
      // setColumns(response.data.data.data.stages);
      return response.data?.data ?? [];
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

      export const AddUser = async (userData:UserData) => {
        try {
          const response = await axiosInstance({
            method: "POST",
            url: `/odoo/api/v1/licenses/addNewSubscription`,
            data: 
              userData
            // },
          });
     
          console.log("Response:", response);
          return response.data;
        } catch (err) {
          console.error("Error fetching stage details:", err);
          throw err;
        }
      };

  